function formatKpiNumber(value, useSeparator) {
    const rounded = Math.round(value);
    if (!useSeparator) {
        return String(rounded);
    }

    return new Intl.NumberFormat('de-DE', {
        maximumFractionDigits: 0,
    }).format(rounded);
}

function renderKpiCounter(el, value, prefix, suffix, useSeparator) {
    const formatted = `${prefix}${formatKpiNumber(value, useSeparator)}${suffix}`;
    const valueEl = el.querySelector('.koch-kpi__counter-value');
    if (valueEl) {
        valueEl.textContent = formatted;
        return;
    }

    el.textContent = formatted;
}

function animateKpiCounter(el) {
    if (el.dataset.kochCounterDone === '1') {
        return;
    }

    el.dataset.kochCounterDone = '1';

    const target = parseFloat(el.dataset.value || '0');
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const useSeparator = el.dataset.separator === '1';

    if (Number.isNaN(target) || target <= 0) {
        renderKpiCounter(el, 0, prefix, suffix, useSeparator);
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        renderKpiCounter(el, target, prefix, suffix, useSeparator);
        return;
    }

    const duration = 1400;
    const start = performance.now();

    const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = target * eased;

        renderKpiCounter(el, current, prefix, suffix, useSeparator);

        if (progress < 1) {
            requestAnimationFrame(tick);
        } else {
            renderKpiCounter(el, target, prefix, suffix, useSeparator);
        }
    };

    requestAnimationFrame(tick);
}

export function initKpiCounters(root = document) {
    const counters = root.querySelectorAll('[data-koch-counter]');
    if (!counters.length) {
        return;
    }

    if (!('IntersectionObserver' in window)) {
        counters.forEach((counter) => animateKpiCounter(counter));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    return;
                }

                animateKpiCounter(entry.target);
                observer.unobserve(entry.target);
            });
        },
        {
            threshold: 0.25,
            rootMargin: '0px 0px -10% 0px',
        }
    );

    counters.forEach((counter) => observer.observe(counter));
}
